export const accountTR = {
    "myAccount": "Hesabım",
    "profile": "PROFİL",
    "addresses": "ADRESLER",
    "history": "GEÇMİŞ",
    "comments": "YORUMLAR",
    "settings": "AYARLAR",
    "psw": "Şifre Değiştir",
    "updateAlert": "Verileriniz başarıyla güncellendi",
    "updateError": "Güncelleme hatası",
    "registerToEdit": "Bilgilerinizi kaydetmek için giriş yapın veya kayıt olun.",
    "addAddress": "Adres ekle",
    "addNewAddress": "Yeni adres ekle",
    "myLocation": "Konumum",    
    "modalHeaderUpdate": "Adres Değiştir",
    "otherLocation": "Diğer Konum",
    "home": "Ev",
    "work": "İş",
    "helperText": "Lütfen adres bilgilerinizi girin",
    "addressComments": "Ek adres açıklamaları",
    "historyPlaceholder": "Henüz alışveriş yapmadınız",
    "commentPlaceholder": "Henüz yorum yapmadınız",
    "emptyHistory": "Henüz sipariş vermediniz.",
    "uploadAvatar": "Farklı bir resim seçmek için resme tıklayın.",
    "submit": "GÖNDER",
    "uploadSuccess": "Dosya yükleme başarılı",    
    "uploadError": "Dosya yükleme hatası",
    "bigFile": "Resim çok büyük. En fazla 1MB olmalıdır. Lütfen daha küçük bir resim seçin",
    "favorites": "Favorilerim",
    "hello": "Merhaba",
    "profileHeader": "Profil",
    "settingsSmall": "Ayarlar",
    "newPassword": "Yeni Şifre",
    "repeatNewPassword": "Yeni Şifreyi Tekrarla",
    "passwordChangeSuccess": "Şifre başarıyla değiştirildi",
    "passwordChangeError": "Şifre değişikliği başarısız oldu, ",
    "passwordMismatch": "Tekrarlanan şifre eşleşmiyor"
}
